import { useMutation } from '@tanstack/react-query';
import apiClient from '../services/ApiService';

export const useBooking = () => {
  return useMutation({
    mutationFn: async (bookingData) => {
      try {
        const response = await apiClient.post('/api/bookings', bookingData);
        return response;
      } catch (error) {
        let errorMessage = 'Failed to create booking. Please try again.';
        
        if (error.response?.data) {
          const data = error.response.data;
          
          if (typeof data.error === 'string') {
            try {
              const parsedError = JSON.parse(data.error);
              errorMessage = parsedError.error?.message || errorMessage;
            } catch (e) {
              errorMessage = data.error;
            }
          } else if (data.error?.message) {
            errorMessage = data.error.message;
          } else if (data.message) {
            errorMessage = data.message;
          }
        }
        
        throw new Error(errorMessage);
      }
    },
  });
};
